export const debounce = (cb, time) => {
    let timeout;

    return (...args) => {
        if (timeout) {
            clearTimeout(timeout);
        }

        timeout = setTimeout(cb, time, ...args);
    };
}